export default {
  state: {
    reservations: {
      isLoading: false,
      items: [],
      checked: [],
      paging: {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0
      },
      sort: {
        order: 'b.pickupTime',
        asc: true
      }
    }
  },
  mutations: {
    // Reservations
    setIsReservationsLoading (state, value) { state.reservations.isLoading = value },
    setReservationItems (state, value) {
      state.reservations.items = value
      state.reservations.checked = []
    },
    pushRsvpItem (state, value) { state.reservations.items.push(value) },
    addReservation (state, value) {
      state.reservations.items.push(value)
    },

    // Checked reservations
    updateCheckedReservations (state, value) { state.reservations.checked = value },
    clearCheckedReservations (state) { state.reservations.checked = [] },

    // Paging mutations
    setReservationsCurrentPage (state, value) { state.reservations.paging.currentPage = value },
    setReservationsTotalPages (state, totalItems) {
      state.reservations.paging.totalPages = Math.ceil(totalItems / state.reservations.paging.pageSize)
    },
    resetReservationsPaging (state) {
      state.reservations.paging = {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0
      }
    },

    // Sorting mutations
    setReservationsSort (state, value) { state.reservations.sort = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/routing/routing-reservations.js